export const BEACON_COOKIE = 'wikia_beacon_id';
export const BEACON_URL_PARAM = 'UBID';
export const BEACON_URL_PARAM_INITIAL_VALUE = '{beacon_id}';
